module.exports = __webpack_public_path__ + "img/jb.4fa0d270.png";